import { useAuth } from "@/auth";
import { isLoggedIn } from "@/auth/utils";
import { defaultRouteAfterLogin, pageLogin } from "@/route";
import { Redirect, useLocation } from "react-router-dom";

export function DefaultPageRedirect() {
  const { session } = useAuth();
  const location = useLocation();

  return (
    <Redirect
      to={
        isLoggedIn(session)
          ? defaultRouteAfterLogin.asString()
          : { pathname: pageLogin.asString(), state: { from: location } }
      }
      push={false}
    />
  );
}
